import {
  tableBodyClasses,
  tableCellClasses,
  tableHeadClasses,
  tableRowClasses,
  type Theme,
  typographyClasses,
} from '@mui/material';
import theme from 'providers/theme/theme';
import type { StyleExtend } from 'providers/theme/theme.types';

export const CoverageTableMobileStyle: StyleExtend<Theme> = {
  [`.${tableCellClasses.root}`]: {
    borderBottom: 'none',
  },
  [`.${tableRowClasses.root}`]: {
    border: `1px solid ${theme.palette.customColors.cream}`,
    borderBottom: 'none',
    borderTop: 'none',
  },
  [`.${tableHeadClasses.root}>.${tableRowClasses.root}:last-of-type>.${tableCellClasses.root}`]: {
    padding: theme.spacing(0, 2),
  },
  [`.${tableBodyClasses.root}>.${tableRowClasses.root}>.${tableCellClasses.root}`]: {
    padding: theme.spacing(0, 2),
  },
  [`.${tableBodyClasses.root}>.${tableRowClasses.root}:last-of-type>.${tableCellClasses.root}`]: {
    padding: theme.spacing(0, 2, 1.25),
  },
  [`.${tableBodyClasses.root}>.${tableRowClasses.root}:last-of-type`]: {
    borderBottom: `1px solid ${theme.palette.customColors.cream}`,
  },
};

export const CoverageTableMobileWorkersCompensationBody: StyleExtend<Theme> = {
  [`&.${tableBodyClasses.root}>.${tableRowClasses.root}:last-of-type`]: {
    borderBottom: 'none',
  },
};

export const CoverageTableMobileTopBar: StyleExtend<Theme> = {
  background: theme.palette.customColors.gunMetal,
  p: theme.spacing(1, 2),
  borderRadius: theme.spacing(0.5, 0.5, 0, 0),
  textAlign: 'center',
  color: theme.palette.common.white,
};

export const CoverageTableMobileWCMessageRowStyle: StyleExtend<Theme> = {
  [`&> .${tableCellClasses.root}`]: {
    borderTop: 'none !important',
    padding: `${theme.spacing(2)} !important`,
  },
};

export const CoverageTableMobileAdditionalDataStacksStyle: StyleExtend<Theme> = {
  mt: 3,
  flexDirection: 'row',
  gap: 1,
  flexWrap: 'wrap',
  [`&> .${typographyClasses.root}`]: {
    fontSize: 14,
    backgroundColor: theme.palette.customColors.lightBeige,
    borderRadius: theme.spacing(0.5),
    textDecorationThickness: theme.spacing(0.25),
    p: theme.spacing(0.5, 1, 1, 1),
  },
};
